import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router';
Vue.use(VueRouter)

import index from './index.vue'

import uploader from '@uploader/customer/layout.vue'
import uploader_router from '@uploader/customer/routes.js'

import core_waybills from '@core_waybills/customer/layout.vue'
import core_waybills_router from '@core_waybills/customer/routes.js'

import partitions from '@partitions/customer/layout.vue'
import partitions_router from '@partitions/customer/routes.js'

import operations from '@operations/customer/layout.vue'
import operations_router from '@operations/customer/routes.js'

const router = [
    {
        path: '', component: index, name: 'customer_index',
    },
    {
        path: 'uploader', component: uploader,
        children: uploader_router
    },
    {
        path: 'core_waybills', component: core_waybills,
        children: core_waybills_router
    },
    {
        path: 'partitions', component: partitions,
        children: partitions_router
    },
    {
        path: 'operations', component: operations,
        children: operations_router
    },
]

export default router;
